import styled from 'styled-components';
import {
  DownOutlined,
  FolderOpenTwoTone,
  GlobalOutlined,
  LeftOutlined,
  LockOutlined,
  MinusOutlined,
  PlusOutlined,
  UserOutlined,
} from '@ant-design/icons';

export const LockIcon = styled(LockOutlined)`
  font-size: 20px;
`;
export const UserIcon = styled(UserOutlined)`
  font-size: 20px;
`;
export const LeftArrowIcon = styled(LeftOutlined)`
  font-weight: bolder;
`;
export const MinusIcon = styled(MinusOutlined)`
  font-weight: bolder;
`;
export const PlusIcon = styled(PlusOutlined)`
  font-weight: bolder;
`;
export const DowmArrowIcon = styled(DownOutlined)`
  font-size: 15px;
  margin-top: 7px;
`;
export const FolderOpenIcon = styled(FolderOpenTwoTone)`
  font-size: 15px;
`;
export const GlobalOutlinedIcon = styled(GlobalOutlined)`
  font-size: 20px;
  opacity: 0.7;
`;
